import createIcon from '../../createIcon';

/**
 * @component @name UTurnLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSA5VjIxSDE3LjVWOUMxNy41IDYuNzkgMTUuNzEgNSAxMy41IDVDMTEuMjkgNSA5LjUgNi43OSA5LjUgOVYxMy4xN0wxMS4wOSAxMS41OEwxMi41IDEzTDguNSAxN0w0LjUgMTNMNS45MSAxMS41OUw3LjUgMTMuMTdWOUM3LjUgNS42OSAxMC4xOSAzIDEzLjUgM0MxNi44MSAzIDE5LjUgNS42OSAxOS41IDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UTurnLeft = createIcon('UTurnLeft', [
  [
    'path',
    {
      d: 'M19.5 9V21H17.5V9C17.5 6.79 15.71 5 13.5 5C11.29 5 9.5 6.79 9.5 9V13.17L11.09 11.58L12.5 13L8.5 17L4.5 13L5.91 11.59L7.5 13.17V9C7.5 5.69 10.19 3 13.5 3C16.81 3 19.5 5.69 19.5 9Z',
      key: 'c6dq4d',
    },
  ],
]);

export default UTurnLeft;
